import { render, staticRenderFns } from "./qr-code.vue?vue&type=template&id=29412424"
import script from "./qr-code.ts?vue&type=script&lang=ts&external"
export * from "./qr-code.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports